import { useEffect } from "react"
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import RealTimeCrowdMonitoring from "./RealTimeCrowdMonitoring";

const RealTimeCrowdMonitoringMain = () => {
    const { t } = useTranslation();
    const { state } = useLocation();

    let edit = state?.edit;
    console.log("looo", t)
    console.log("looo1", edit)
    useEffect(() => {
        GridStack.init();
    }, []);

    const layoutData = [
        // {
        //     x: 0,
        //     y: 0,
        //     width: 12,
        //     height: 1,
        //     id: 0,
        //     component: (
        //         <DMSHeader
        //             title={t("Real Time Monitoring")}
        //             // showIconsForback={edit}
        //         />
        //     ),
        //     haveOverflowVisible: true,
        // },
        {
            x: 0,
            y: 1,
            width: 12,
            height: 23,
            id: 1,
            component: <RealTimeCrowdMonitoring />,
        },
    ];

    return (
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
            <GridItem layoutData={layoutData} />
        </div>
    );
}

export default RealTimeCrowdMonitoringMain;